import { useState, useEffect, useCallback } from 'react';

// https://stackoverflow.com/a/60978633
export const useContainerDimensions = (myRef) => {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  const getDimensions = useCallback(() => ({
    width: myRef?.current?.offsetWidth || 0,
    height: myRef?.current?.offsetHeight || 0,
  }), [myRef]);

  useEffect(() => {
    const handleResize = () => {
      if (myRef && myRef?.current) {
        setDimensions(getDimensions());
      }
    };

    if (myRef && myRef?.current) {
      setDimensions(getDimensions());
    }

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [myRef, getDimensions]);

  return dimensions;
};
